import { useRef, useState } from "react";

import { Box, Button, Paper, Stack } from "@mui/material";
import CelebrationIcon from "@mui/icons-material/Celebration";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";

import { GiftItem, userState } from "../../../../interface/MainInterface";
import { HttpAdminApi } from "../../../../interface/admin-api";
import LoadingCircle from "../../../../utils/LoadingCircle";
import Toast from "../../../../utils/Toast";
import CreateEventForm from "./CreateEventForm";

interface propsType {
  userState: userState;
  channelInfo: any;
  callback: any;
  eventCount: number;
  closeCreateEventForm: () => void;
}

const adminApi = new HttpAdminApi();

const CreateEventFormMudule = (props: propsType) => {
  const toastRef: any = useRef();

  const [isLoading, setIsLoading] = useState(false);
  const [flag, setFlag] = useState("");

  // 이벤트 생성하기
  const create_event = async (
    eventName: string,
    isFcfs: boolean,
    timeoutMin: number,
    timeoutSec: number,
    giftList: GiftItem[]
  ) => {
    const param: any = {
      command: "create_event",
      channel_pk: props.channelInfo.channel_pk,
      broad_seq: props.channelInfo.broad_seq,
      manager_id: props.userState.id,
      event_info: {
        evntNo: `${props.eventCount + 1}`,
        evntNm: eventName,
        subEvntNm: "",
        startDtm: "",
        endDtm: "",
        evntPtcGbcd: "",
        ofrList: giftList,
        timeout: timeoutMin * 60 + timeoutSec * 1,
        is_fcfs: isFcfs,
        flag: flag,
      },
    };

    setIsLoading(true);
    const res = await adminApi.post(param);
    if (res.code === "200") {
      // clearCreateFrom();
      props.callback({ command: "finish_create_evnet" });
    } else {
      console.error("create_event : ", res.response.error_msg);
      toastRef.current?.toast("이벤트 생성에 실패했습니다.", "error", 4000, { vertical: "top", horizontal: "center" });
    }
    setIsLoading(false);
  };

  return (
    <>
      <Paper elevation={5}>
        <Box sx={{ p: 1 }}>
          <Stack direction={"column"} spacing={2}>
            {/* 이벤트 종류 */}
            <Box>
              <Stack direction={"row"} spacing={2}>
                <Box>
                  <Button
                    variant={flag === "apply" ? "contained" : "outlined"}
                    startIcon={<CelebrationIcon />}
                    onClick={() => {
                      setFlag(flag === "apply" ? "" : "apply");
                    }}
                  >
                    응모 이벤트
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant={flag === "authBuy" ? "contained" : "outlined"}
                    startIcon={<ShoppingCartIcon />}
                    onClick={() => {
                      setFlag(flag === "authBuy" ? "" : "authBuy");
                    }}
                  >
                    구매인증 이벤트
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant={flag === "game" ? "contained" : "outlined"}
                    startIcon={<SportsEsportsIcon />}
                    onClick={() => {
                      setFlag(flag === "game" ? "" : "game");
                    }}
                  >
                    게임 이벤트
                  </Button>
                </Box>
              </Stack>
            </Box>
            {flag !== "" && (
              <CreateEventForm
                userState={props.userState}
                title={
                  flag === "apply"
                    ? "n명 응모자 당첨 이벤트입니다."
                    : flag === "authBuy"
                    ? "구매인증한 사람 중 n명을 추첨하는 이벤트입니다."
                    : "게임 이벤트입니다. 이벤트 생성 후 게임 유형을 선택해주세요."
                }
                flag={flag}
                createGameFn={create_event}
                closeCreateEventForm={props.closeCreateEventForm}
              />
            )}
          </Stack>
        </Box>
      </Paper>
      <LoadingCircle loading={isLoading} />
      <Toast ref={toastRef} />
    </>
  );
};

export default CreateEventFormMudule;
